export default "__VITE_ASSET__BS7AyZj8__"